import React, { useEffect } from "react";
import { SettingsSelectBoxWrapper } from "../styled/styled";
import { Button } from "../../../common/styles/muiStyled";
import { EventAutocompleteOption } from "../../globalSettings/types";
import { useTranslation } from "react-i18next";
import { useEventDropdown } from "../hooks/useEventDropdown/useEventDropdown";
import { EventSelector } from "./eventSelector/EventSelector";

export type EventSelectBoxProps = {
  isLoading: boolean;
  isError: boolean;
  options: EventAutocompleteOption[];
  getMercuryShows: () => Promise<void>;
  fetchEventEdition: (eventEditionId: string) => Promise<void>;
  fetchCounties: () => Promise<void>;
};

const EventSelectBox: React.FC<EventSelectBoxProps> = ({
  isLoading,
  isError,
  options,
  getMercuryShows,
  fetchEventEdition,
  fetchCounties
}) => {
  const { t } = useTranslation("common");
  const {
    selectedOption,
    isSubmitting,
    isButtonClicked,
    filteredOptions,
    onDropdownClick,
    onClick,
    onChange,
    onSelect,
    onClickAway
  } = useEventDropdown({ options, fetchEventEdition, fetchCounties });

  useEffect(() => {
    getMercuryShows();
  }, []);

  const isFormDisabled = Boolean(isError || isLoading || isSubmitting);

  return (
    <SettingsSelectBoxWrapper>
      <span>{t("selectEventPage.selectEventTitle")}</span>
      {isButtonClicked && <div onClick={onDropdownClick} className={'backdrop'} />}
      <p className={'subtitle'}>{t("settings.eventEdition")}</p>
      <EventSelector
        isButtonClicked={isButtonClicked}
        onDropdownClick={onDropdownClick}
        isFormDisabled={isFormDisabled}
        selectedOption={selectedOption}
        options={options}
        onChange={onChange}
        onSelect={onSelect}
        filteredOptions={filteredOptions}
        onClickAway={onClickAway}
      />
      <Button className={'confirm-button'} tabIndex={0} aria-selected variant={"contained"} disabled={isFormDisabled || !selectedOption} onClick={onClick}>
        {isLoading || isSubmitting ? t("selectEventPage.loading") : t("selectEventPage.confirm")}
      </Button>
    </SettingsSelectBoxWrapper>
  );
};

export default EventSelectBox;
